import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import useToggle from 'hooks/useToggle'
import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import Image from 'components/Common/Image'
import PaneDetailsSection from 'components/Common/Pane/PaneDetailsSection'
import PaneBody from 'components/Common/Pane/PaneBody'
import AspectRatio from 'components/utils/AspectRatio'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import SolidSquareShapeIcon from 'LuxKit/Icons/solid/SolidSquareShapeIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-column-gap: ${rem(24)};
    grid-template-columns: 2fr 4fr;
  }
`

const TileMediaContainer = styled(AspectRatio)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

const TileMediaContainerImage = styled(Image)`
  border-radius: ${props => props.theme.borderRadius.S};
  width: 100%;
`

const CabinCategoryList = styled.div`
  border-radius: ${props => props.theme.borderRadius.S};
  border: ${rem(1)} solid ${props => props.theme.palette.neutral.default.six};
  padding: ${rem(16)};
`

interface Props {
  cabinCategory: App.CruiseShipCabinCategory
}
function CabinCategoriesModalContent({ cabinCategory }: Props) {
  const [showMoreOpenned, onToggleShowMore] = useToggle()

  const renderCabinDescription = (text: string, isFullText?: boolean): string => {
    return isFullText ? text : `${text.slice(0, 110)}...`
  }

  return (
    <CabinCategoryList key={cabinCategory.id}>
      <Group direction="vertical" gap={8}>
        <GridContainer>
          <TileMediaContainer ratio="3:2">
            <TileMediaContainerImage
              id={cabinCategory.imageId}
              aspectRatio="3:2"
              width="400"
            />
          </TileMediaContainer>
          <Group direction="vertical" gap={8}>
            <Heading variant="heading5" as="span">
              {cabinCategory.cabinCategoryInfo ? cabinCategory.cabinCategoryInfo[0].name : cabinCategory.cabinType}
            </Heading>

            {!!cabinCategory.color && <SolidSquareShapeIcon style={{ color: cabinCategory.color }} />}
            <BodyText variant="medium">
              {renderCabinDescription(cabinCategory.cabinCategoryInfo ? cabinCategory.cabinCategoryInfo[0].description : '')}
            </BodyText>

            <SmallToggleButton
              on={showMoreOpenned}
              size="medium"
              iconPosition="end"
              onClick={onToggleShowMore}
            >{showMoreOpenned ? 'Read less' : 'Read more'}
            </SmallToggleButton>
          </Group>
        </GridContainer>

        <PaneDetailsSection isOpen={showMoreOpenned}>
          <PaneBody size="sm zero-x">
            <Group direction="vertical" gap={8}>
              <BodyText variant="medium" weight="bold">
                About this cabin
              </BodyText>
              <BodyText variant="medium">
                {renderCabinDescription(cabinCategory.cabinCategoryInfo ? cabinCategory.cabinCategoryInfo[0].description : '', true)}
              </BodyText>
            </Group>
          </PaneBody>
        </PaneDetailsSection>
      </Group>
    </CabinCategoryList>
  )
}

export default CabinCategoriesModalContent
